import type { ComputedRef, WritableComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { Subscription } from '@entities/subscription'

import { useSubscriptionsStore } from './store'
import {
  fromAgentValue,
  getAgentOptions,
  toAgentValue,
} from './subscription-rules'

interface UseSubscriptionDealOwnerOptions {
  subscription: ComputedRef<Subscription>
  agentId: ComputedRef<number | null>
  onChange: (agentId: number | null) => void
}

interface SubscriptionDealOwnerReturn {
  refValue: WritableComputedRef<number>
  options: ComputedRef<AppSelectOption<number>[]>
}

export const useSubscriptionDealOwner = ({
  subscription,
  agentId,
  onChange,
}: UseSubscriptionDealOwnerOptions): SubscriptionDealOwnerReturn => {
  const store = useSubscriptionsStore()

  const options = computed<AppSelectOption<number>[]>(() => getAgentOptions(store.getAgents, subscription.value))

  const refValue = computed<number>({
    get: () => toAgentValue(agentId.value),
    set: value => onChange(fromAgentValue(value)),
  })

  return {
    refValue,
    options,
  }
}
